import classNames from "classnames";
import { KickLogo } from "@design-system/KickLogo/KickLogo";
import {
    kickLogoFormatLabels,
    kickLogoFormatProps,
    kickLogoFormats,
    kickLogoPaints,
    kickLogoSizePixels,
    kickLogoSizes,
} from "./KickLogoPlayground.lib";
import styles from "./KickLogoPlayground.module.scss";

type KickLogoSurface = "primary" | "inverse";

const surfaces: ReadonlyArray<{ id: KickLogoSurface; title: string }> = [
    { id: "primary", title: "On --bg-primary" },
    { id: "inverse", title: "On --bg-inverse" },
];

const paintRows = kickLogoPaints.map((paint) => ({
    ...paint,
    id: `${paint.color}-${paint.transparent ? "transparent" : "opaque"}`,
}));

/** Figma's KickLogo and KickIcon sets: every artwork x colour x transparency, on a light and a dark surface. */
export const KickLogoVariantMatrix = () => (
    <>
        {surfaces.map((surface) => (
            <section key={surface.id} className={styles.section}>
                <h2 className={styles.sectionTitle}>{surface.title}</h2>
                <div
                    className={classNames(styles.surface, styles.grid)}
                    data-surface={surface.id}
                >
                    <span />
                    {kickLogoFormats.map((format) => (
                        <code key={format} className={styles.headerCell}>
                            {kickLogoFormatLabels[format]}
                        </code>
                    ))}
                    {paintRows.map((row) => (
                        <div key={row.id} className={styles.row}>
                            <code className={styles.headerCell}>{row.id}</code>
                            {kickLogoFormats.map((format) => (
                                <KickLogo
                                    key={format}
                                    {...kickLogoFormatProps[format]}
                                    color={row.color}
                                    transparent={row.transparent}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        ))}
    </>
);

/** Every size of every artwork, black and opaque, largest first. */
export const KickLogoSizeMatrix = () => (
    <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Sizes</h2>
        <div
            className={classNames(styles.surface, styles.grid)}
            data-surface="primary"
        >
            <span />
            {kickLogoFormats.map((format) => (
                <code key={format} className={styles.headerCell}>
                    {kickLogoFormatLabels[format]}
                </code>
            ))}
            {kickLogoSizes.map((size) => (
                <div key={size} className={styles.row}>
                    <code className={styles.headerCell}>
                        {`${size} · ${kickLogoSizePixels[size]}px`}
                    </code>
                    {kickLogoFormats.map((format) => (
                        <KickLogo
                            key={format}
                            {...kickLogoFormatProps[format]}
                            size={size}
                        />
                    ))}
                </div>
            ))}
        </div>
    </section>
);
